import React from "react";
import useLanguageChange from "../../hooks/useLanguageChange";
import clsx from "clsx";
import extractTextService from "../../services/extractTextService";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import { AR_MARKUP_VIEW, MARKUP_VIEW } from "../../constants/Constants";

const PrepareMarkupView = ({ showPrepareView, type }) => {
    const localisedValues = useLanguageChange();
    const { markupInprogress, arMarkupLiveStream } = useSelector((state) => state.markup);

    const sendCancelMarkupOCRPrepareView = () => {
        extractTextService.sendCancelMarkupOCRPrepareView(type);
    };

    return (
        <div className={clsx("process-waiting annotation-process-waiting", !showPrepareView && "d-none")} data-testid='prepare-markup-view'>
            <div className='process-waiting-in custom-scroll'>
                <div className='process-waiting-box text-center'>
                    <div className='process-waiting-icon'>
                        <span
                            className={clsx("for-icon", markupInprogress && "icon-prepare-markup", arMarkupLiveStream && "icon-prepare-ar-markup")}
                        ></span>
                    </div>
                    <div className='process-waiting-text'>
                        {markupInprogress === MARKUP_VIEW.PREPARE_VIEW && (
                            <div className='process-waiting-text-bar'>{localisedValues?.preparing_image_for_markup}</div>
                        )}
                        {arMarkupLiveStream === AR_MARKUP_VIEW.PREPARE_VIEW && (
                            <div className='process-waiting-text-bar'>{localisedValues?.preparing_view_for_ar_markup}</div>
                        )}
                    </div>
                    <div className='process-waiting-text-bottom' id='timeOutScreen_Markup' style={{ display: "none" }}>
                        <div className='process-waiting-text-bottom-bar'>{localisedValues?.markup_ocr_upload_timeout}</div>
                        <div className='process-waiting-text-bottom-bar'>
                            <button className='btn' onClick={sendCancelMarkupOCRPrepareView}>
                                {localisedValues?.click_here}
                            </button>
                            {localisedValues?.to_return_to_video_and_try_again}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

PrepareMarkupView.propTypes = {
    showPrepareView: PropTypes.bool,
    type: PropTypes.string,
};

export default PrepareMarkupView;
